import { WATERMARK_OVERLAY_ID } from "./videoWatermarkTypes";

export function watermarkCss(): string {
  return `
    .${WATERMARK_OVERLAY_ID}-protected,
    .${WATERMARK_OVERLAY_ID}-protected * {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      user-select: none !important;
      -webkit-user-drag: none !important;
      -webkit-touch-callout: none !important;
    }
    .${WATERMARK_OVERLAY_ID}-floating {
      position: absolute !important;
      left: 0 !important;
      top: 0 !important;
      pointer-events: none !important;
      user-select: none !important;
      -webkit-user-select: none !important;
      font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace !important;
      color: rgba(255, 255, 255, 0.55) !important;
      text-shadow: 0 0 4px rgba(0, 0, 0, 0.7), 0 1px 2px rgba(0, 0, 0, 0.8) !important;
      font-size: 11px !important;
      letter-spacing: 0.12em !important;
      white-space: nowrap !important;
      mix-blend-mode: difference !important;
      z-index: 2147483600 !important;
      opacity: 0.34 !important;
      will-change: transform !important;
      animation: deepmoxWatermarkDrift var(--dm-watermark-duration, 34s) linear infinite !important;
      animation-delay: var(--dm-watermark-delay, 0s) !important;
    }
    @keyframes deepmoxWatermarkDrift {
      0% {
        transform: translate3d(-28vw, var(--dm-watermark-y-start, 12vh), 0) rotate(var(--dm-watermark-angle, 0deg));
      }
      45% {
        transform: translate3d(42vw, var(--dm-watermark-y-mid, 52vh), 0) rotate(var(--dm-watermark-angle, 0deg));
      }
      100% {
        transform: translate3d(108vw, var(--dm-watermark-y-end, 20vh), 0) rotate(var(--dm-watermark-angle, 0deg));
      }
    }
    video.${WATERMARK_OVERLAY_ID}-video {
      controlsList: nodownload noremoteplayback !important;
      disableremoteplayback: true !important;
    }
  `;
}

export function injectWatermarkStyles() {
  const id = "deepmox-video-watermark-style";
  const existing = document.getElementById(id);
  if (existing) return existing;
  const style = document.createElement("style");
  style.id = id;
  style.textContent = watermarkCss();
  document.head.appendChild(style);
  return style;
}

export function preventDefault(event: Event) {
  event.preventDefault();
  event.stopPropagation();
}

export function ensureContainerRelative(el: HTMLElement) {
  if (getComputedStyle(el).position === "static") {
    el.style.position = "relative";
  }
  el.classList.add(`${WATERMARK_OVERLAY_ID}-protected`);
  el.addEventListener("contextmenu", preventDefault, { passive: false });
  el.addEventListener("dragstart", preventDefault, { passive: false });
}

export function hardenVideoElement(video: HTMLVideoElement) {
  video.classList.add(`${WATERMARK_OVERLAY_ID}-video`);
  video.setAttribute("controlsList", "nodownload noremoteplayback");
  video.setAttribute("disableremoteplayback", "true");
  video.setAttribute("oncontextmenu", "return false");
  (video.style as any).webkitTouchCallout = "none";
  video.addEventListener("contextmenu", preventDefault, { passive: false });
  video.addEventListener("dragstart", preventDefault, { passive: false });
}
